import { render, staticRenderFns } from "./Question.vue?vue&type=template&id=219cdccb&scoped=true"
import script from "./Question.vue?vue&type=script&lang=js"
export * from "./Question.vue?vue&type=script&lang=js"
import style0 from "./Question.vue?vue&type=style&index=0&id=219cdccb&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "219cdccb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/admin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('219cdccb')) {
      api.createRecord('219cdccb', component.options)
    } else {
      api.reload('219cdccb', component.options)
    }
    module.hot.accept("./Question.vue?vue&type=template&id=219cdccb&scoped=true", function () {
      api.rerender('219cdccb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Survey/View/Question.vue"
export default component.exports